module.exports = {"domain":"dev-ikrrwmo3.us.auth0.com","clientId":"ycakUERgFL37BK0X1nCOcSDx6LlJXGqJ"}


//////////////////
// WEBPACK FOOTER
// ./auth_config.json
// module id = kMb3
// module chunks = 1